import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    noUploadsTitle: string;
    noUploadsDescription: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title shown when there are no uploads */
            noUploadsTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NoUploads.noUploadsTitle?c=1pnf1g9k1f6ij", defaultMessage: "No Uploads" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description text explaining where uploads will appear */
            noUploadsDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NoUploads.noUploadsDescription?c=b781hu1n4ae1", defaultMessage: "In-progress and past uploads will show up here." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
